package com.macrofocus.eflux.ui.perspective

import com.macrofocus.colormapping.implementation.SimpleColorMapping
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.toRawString
import com.macrofocus.high_d.axis.AxisModel
import com.macrofocus.trenddisplay.TimeSeriesPlot
import com.macrofocus.trenddisplay.TrendDisplayLogic
import com.macrofocus.trenddisplay.TrendDisplaySettings
import com.macrofocus.trenddisplay.timeseriesplot.DefaultTimeSeriesPlotModel
import com.macrofocus.trenddisplay.timeseriesplot.TimeSeriesPlotModel
import com.macrofocus.visual.SimpleVisual
import com.macrofocus.visual.SimpleVisualObjects
import js.objects.unsafeJso
import kotlinx.browser.window
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import org.mkui.colormap.ColorMapFactory
import org.mkui.component.CPComponent
import org.mkui.component.CPFactory
import org.mkui.react.useProperty
import org.molap.dataframe.DataFrame
import org.molap.questdb.DateTimeHandling
import org.molap.questdb.readQuestDBJson
import org.molap.subset.SubsetDataFrame
import react.FC
import react.Props
import react.useEffect
import react.useState
import web.cssom.Position
import web.cssom.px

class TimeSeriesPerspective(private val dataLoader: DataLoader) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> {
        val theme = useTheme<Theme>()

        val (TimeSeriesPlotModel, setTimeSeriesPlotModel) = useState<TimeSeriesPlotModel<Int, String>?>(null)

        val (getShiftedDateTime, _) = useProperty(dataLoader.masterDateTime)
        val shiftedDateTime = getShiftedDateTime.toRawString()

        useEffect(shiftedDateTime) {
            window.fetch("db/logicalBranchesT/$shiftedDateTime").then {
                it.text().then {
                    val dataFrame = DataFrame.readQuestDBJson(it, DateTimeHandling.Instant)
                    val subsetDataFrame = SubsetDataFrame(dataFrame)

                    val colorMapFactory = ColorMapFactory.instance
                    val visual = SimpleVisual(
                        SimpleVisualObjects<Int>(dataFrame), SimpleColorMapping<Int, String>(
                            colorMapFactory, dataFrame
                        )
                    )

                    val settings = TrendDisplaySettings<String>()
                    settings.id.value = "logicalBranchId"
                    settings.time.value = "datetime"
                    val logic = TrendDisplayLogic<Int, String, Any?>(
                        dataFrame,
                        settings, CPFactory.instance, colorMapFactory
                    )

                    val model = DefaultTimeSeriesPlotModel<Int, String>(CPFactory.instance, colorMapFactory, logic)
                    settings.id.value = "logicalBranchId"
                    settings.time.value = "datetime"
                    model.y.setSelectedElement(model.axisGroupModel.getAxisModel("pratea") as AxisModel<Int, String>)

                    setTimeSeriesPlotModel(model)
                }
            }
        }

        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Paper {
            sx = unsafeJso {
                position = Position.absolute
                top = 0.px
                bottom = 0.px
                left = 0.px
                right = 0.px

                customBackground(this)
            }

            TimeSeriesPlot {
                this.model = TimeSeriesPlotModel
            }
        }
    }

}